import React from "react";
import "./groupdesign/GroupInvitations.css";
import { resolveAvatarUrl, handleAvatarError } from "../../utils/profilePicUrl";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost/cool/my-app/backend";

function getDisplayName(user) {
  const full = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  return full || user.username || "Unknown user";
}

function getInviterDisplayName(invite) {
  const full = [invite.invited_by_first_name, invite.invited_by_last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  return full || invite.invited_by || "Someone";
}

export default function GroupInvitations({
  pendingInvites,
  sentInvites,
  selectedTab,
  respondToInvite,
}) {
  if (selectedTab === "pending") {
    return (
      <div className="invite-card">
        <div className="invite-header">
          <h4 className="invite-title">Pending Invitations</h4>
          <p className="invite-subtitle">Groups you have been invited to</p>
        </div>

        {pendingInvites.length === 0 ? (
          <p className="invite-empty">No pending invites.</p>
        ) : (
          <ul className="invite-user-list">
            {pendingInvites.map((group) => (
              <li key={group.id} className="invite-user-card">
                <img
                  className="invite-user-avatar"
                  src={resolveAvatarUrl(
                    { profile_pic: group.invited_by_pic || group.group_photos },
                    API_URL
                  )}
                  alt={group.invited_by || group.name}
                  onError={handleAvatarError}
                />
                <div className="invite-user-body">
                  <div className="invite-user-name">{group.name}</div>
                  <div className="invite-user-meta">
                    Invited by {getInviterDisplayName(group)}
                  </div>
                  {group.description ? (
                    <div className="invite-user-extra">{group.description}</div>
                  ) : null}
                  <div className="invite-actions">
                    <button
                      className="btn accept"
                      onClick={() => respondToInvite(group.id, "accept")}
                    >
                      Accept
                    </button>
                    <button
                      className="btn decline"
                      onClick={() => respondToInvite(group.id, "decline")}
                    >
                      Decline
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  if (selectedTab === "sent") {
    return (
      <div className="invite-card">
        <div className="invite-header">
          <h4 className="invite-title">Sent Invitations</h4>
          <p className="invite-subtitle">People you invited to a group</p>
        </div>

        {sentInvites.length === 0 ? (
          <p className="invite-empty">No invites sent.</p>
        ) : (
          <ul className="invite-user-list">
            {sentInvites.map((invite, i) => (
              <li
                key={`${invite.user_id}-${invite.group_id}-${i}`}
                className="invite-user-card"
              >
                <img
                  className="invite-user-avatar"
                  src={resolveAvatarUrl(invite, API_URL)}
                  alt={invite.username}
                  onError={handleAvatarError}
                />
                <div className="invite-user-body">
                  <div className="invite-user-name">{getDisplayName(invite)}</div>
                  <div className="invite-user-meta">
                    @{invite.username}
                    {invite.email ? ` · ${invite.email}` : ""}
                  </div>
                  <div className="invite-user-extra">
                    {[invite.typeofuser, invite.country, `Invited to ${invite.group_name}`]
                      .filter(Boolean)
                      .join(" · ")}
                  </div>
                </div>
                <span className="invite-check pending" title="Pending">
                  …
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  return null;
}
